import { useEffect, useState } from 'react';
import { Subscription } from 'rxjs';
import { CompanyClient } from '@api/CompanyClient';
import { PTVNResponse } from '@api/response/BaseResponse';
import { ConsentResponseSC } from '@api/response/ConsentResponse';

export const useConsentAcceptance = () => {
    const [subscription, setSubscription] = useState<Subscription>();

    const autoAcceptConsentSC = (res: PTVNResponse<ConsentResponseSC[]>, source: string) => {
        if (res && res.data && Array.isArray(res.data)) {
            const applications = res.data.map((item: ConsentResponseSC) => item.application).filter(Boolean);

            if (applications.length > 0) {
                const payload = { application: applications };

                const subscriptionAcceptConsent = CompanyClient.acceptConsentBulk(payload).subscribe(
                    (acceptRes: any) => {
                        // console.log(`Consent accepted successfully (${source}):`, acceptRes);
                    },
                    (acceptErr: any) => {
                        // console.error(`Failed to accept consent (${source}):`, acceptErr);
                    }
                );

                return subscriptionAcceptConsent;
            } else {
                // console.log(`No consent data found to accept (${source})`);
            }
        } else {
            // console.log(`No consent response data available (${source})`);
        }
        return null;
    };

    const initializeConsentAcceptance = () => {
        const subscriptions: Subscription[] = [];
        const subscriptionGetRequestConsent = CompanyClient.getRequestConsentV2().subscribe(res => {
            if (res.data?.length > 0) {} else {
                try {
                    const subscriptionGetConsent = CompanyClient.getTermAndCondition().subscribe(
                        (consentRes: any) => {
                            try {
                                const acceptSubscription = autoAcceptConsentSC(consentRes, 'Auto acceptanace SC');
                                if (acceptSubscription) {
                                    subscriptions.push(acceptSubscription);
                                }
                            } catch (processError) {
                                // console.error('Error in processConsentData:', processError);
                            }
                        },
                        (err: any) => {
                            // console.error('Failed to Auto accept consent:', err);
                        },
                        () => {
                            // console.log('COMPLETE - getConsentSC subscription completed');
                        }
                    );
                    subscriptions.push(subscriptionGetConsent);

                } catch (subscriptionError) {
                    // console.error('Error while creating getConsentSC subscription:', subscriptionError);
                }
            }
        }, error => {
            console.error('Failed to get request-v2 consent:', error);
        });

        subscriptions.push(subscriptionGetRequestConsent);
        // Combine all subscriptions
        const combinedSubscription = subscriptionGetRequestConsent.add(...subscriptions.slice(1));
        setSubscription(combinedSubscription);

        return subscriptions;
    };

    useEffect(() => {
        return () => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        };
    }, [subscription]);

    return {
        initializeConsentAcceptance,
        autoAcceptConsentSC
    };
};
